import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Action } from 'rxjs/internal/scheduler/Action';
import { MailTemplateModel } from '../../../models/mail/mail-template.model';
import { PreviewMailModel } from '../../../models/mail/preview-mail.model';
import { SendMailModel } from '../../../models/mail/send-mail.model';
import { CommunicationLogPagingGetDto } from '../../models/communication-log.model';
import * as Actions from './mail.action';
import * as Selectors from './mail.selector';

@Injectable()
export class MailFacade {
  saveMailTemplate$ = this.store.select(Selectors.selectSaveMail);
  mailMembers$ = this.store.select(Selectors.selectMailMemberTemplates);
  mailTemplate$ = this.store.select(Selectors.selectMailTemplate);
  previewMail$ = this.store.select(Selectors.selectPreviewMail);
  communicationLogs$ = this.store.select(Selectors.selectCommunicationLogs);
  communicationErrors$ = this.store.select(Selectors.selectCommunicationError);
  replyToEmailAddress$ = this.store.select(Selectors.selectSaveReplyToEmailAddress);
  emailSaveError$ = this.store.select(Selectors.selectEmailSaveError);
  emailSaveSuccess$ = this.store.select(Selectors.selectEmailSaveSuccess);

  sentMailLogs$ = this.store.select(Selectors.selectSentMailLogs);
  loading$ = this.store.select(Selectors.selectSentMailLogLoading);
  error$ = this.store.select(Selectors.selectSentMailLogError);

  constructor(private store: Store) {}

  public loadSentMailLogs(sentMailLogId:number): void {
    this.store.dispatch(Actions.loadSentMailLogs({ sentMailLogId }));
  }
  public previewMail(model: PreviewMailModel): void {
    this.store.dispatch(Actions.PreviewMail({ model: model }));
  }
  public saveMailTemplate(model: MailTemplateModel): void {
    this.store.dispatch(Actions.SaveMailTemplate({ model: model }));
  }

  public getCommunicationLogs(log: CommunicationLogPagingGetDto): void {
    this.store.dispatch(Actions.GetCommunicationLogs({ log }));
  }

  public getMailMembers(memberIds: string): void {
    this.store.dispatch(Actions.GetMailMemberTemplates({ memberIds }));
  }
  public getMailTemplate(id: number): void {
    this.store.dispatch(Actions.GetMailTemplate({ id }));
  }
  public removeMailMember(index: number): void {
    this.store.dispatch(Actions.DeleteMailMemberTemplates({ index }));
  }
  public saveReplyToEmailAddress(replyToEmailAddress: string) {
    this.store.dispatch(Actions.SaveReplyToEMailAddress( { emailAddress: replyToEmailAddress }));
  }

  public saveReplyToEmailAddressSuccess() {
    this.store.dispatch(Actions.SaveReplyToEMailAddresssSuccess( { response: false }));
  }

  public saveReplyToEmailAddressError() {
    this.store.dispatch(Actions.SaveReplyToEMailAddressFailure( { err: null }));
  }
}
